module.exports = __webpack_public_path__ + "img/post1.cd84c85d.png";